import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    customColor: {
      main: "#159AA8",
    },
  },
});

export default theme;
